import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import SentryFullStory from '@sentry/fullstory';
import { BrowserTracing } from '@sentry/tracing';
import { AppModule } from './app/app.module';
import { ENVIRONMENT } from './environments/environment';
import {
  ignoreErrors,
  ignoreUrls as denyUrls,
} from './sentry-junk-error-patterns';

function initSentry() {
  Sentry.init({
    dsn: ENVIRONMENT.sentryDsn,
    environment: ENVIRONMENT.environment_name,
    release: ENVIRONMENT.version,
    integrations: [
      new BrowserTracing({
        tracingOrigins: [ENVIRONMENT.apiBase],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
      new SentryFullStory('funding-societies'),
    ],
    tracesSampleRate: 0.25,
    ignoreErrors,
    denyUrls,
  });
}

if (ENVIRONMENT.production) {
  if (ENVIRONMENT.sentry_logging) {
    initSentry();
  }
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  preserveWhitespaces: true,
});
